import {useDebugValue} from 'react';

import classNames from 'classnames';

import {useSearchFormContext} from '../../../hooks/useSearchFormContext';
import {useTrackingContext} from '../../../hooks/useTrackingContext';

import {triggerDetailsModalCloseEdapEvent} from '../../../utils/edap';

const classNamespace = 'search-form';
const modalClassName = `${classNamespace}__modal`;
const detailsModalClassName = `${classNamespace}__details-modal`;

function useComponent() {
    const searchFormContext = useSearchFormContext();

    const {
        edapOptions,
        detailsModalActions: {
            setIsOpen
        },
        detailsModalEvents: {
            onClose,
            onOpen,
            onSecondaryActionClick
        },
        detailsModalOptions: {
            id,
            fixedBody,
            parentNode,
            portalClassName,
            isContextual,
            isInstructional,
            isWorkflow,
            footer,
            showBackdrop,
            showHeader,
            showCloseButton,
            closeOnEsc,
            closeOnOutsideClick,
            animation,
            timeouts,
            scrollTop,
            scrollToTop
        },
        detailsModalSettings: {
            isOpen,
            isLoading,
            isSecondaryActionDisabled
        },
        translations: {
            titleMessage,
            closeButtonLabel,
            secondaryActionLabel
        }
    } = searchFormContext;

    let {
        detailsModalOptions: {
            title
        }
    } = searchFormContext;

    const trackingContext = useTrackingContext();

    const className = classNames(modalClassName, detailsModalClassName);

    title = title || titleMessage;

    const modalAnimation = animation && `modal-from-${animation}`;

    function handleClose(/* ...args */) {
        triggerDetailsModalCloseEdapEvent(trackingContext, edapOptions);

        setIsOpen(false);
    }

    function handleModalOpen(...args) {
        onOpen(...args);
    }

    function handleModalClose(...args) {
        onClose(...args);
    }

    /* istanbul ignore next */
    function handleSecondaryActionClick(...args) {
        onSecondaryActionClick(...args);
    }

    const result = {
        id,
        className,
        fixedBody,
        parentNode,
        portalClassName,
        isContextual,
        isInstructional,
        isWorkflow,
        renderBackdrop: showBackdrop,
        header: showHeader,
        title,
        closeButton: showCloseButton,
        closeText: closeButtonLabel,
        secondaryActionLabel,
        footer,
        isOpen,
        isLoading,
        secondaryActionDisabled: isSecondaryActionDisabled,
        closeOnEsc,
        closeOnOutsideClick,
        modalAnimation,
        timeouts,
        scrollTop,
        scrollToTop,
        onClose: handleClose,
        onModalOpen: handleModalOpen,
        onModalClose: handleModalClose,
        secondaryActionCallback: handleSecondaryActionClick
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
